"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M20.414 13.711h-6.482v6.539h-3.558v-6.539H3.586l8.409-9.961z"
}), 'LongArrowUp');
//# sourceMappingURL=index.js.map